import style from './GenericPageLayout.module.scss';
import React, { useEffect } from 'react';
import { SharedDataType, useGlobalContentContext } from 'context/GlobalContentContext';
import { StandardBlocksLayout } from 'components/general/blocks/standardBlocksLayout/StandardBlocksLayout';
import { BlockType } from 'components/general/blocks/switchBlock/SwitchBlock';
import { MainFooter } from 'components/mainFooter/MainFooter';

export type GenericPageLayoutProps = {
  blockStyles?: string | undefined | null; //// we can overwrite content blocks from the CMS here
  blocks: BlockType[];
  meta_title: string;
  meta_description: string;
  meta_image: string;
  title: string;
  heading: string;
  intro: string;
  originalResponse: any;
} & { children: React.ReactNode } & { globalData: SharedDataType };

const GenericPageLayout = (props: GenericPageLayoutProps) => {
  const {
    intro,
    title,
    meta_description,
    meta_image,
    meta_title,
    blocks,
    heading,
    // connectTaglineHtml,
    blockStyles,
    children,
    globalData,
  } = props;

  const { setData } = useGlobalContentContext();
  useEffect(() => {
    // TODO: get from props
    setData(globalData);
  }, []);

  return (
    <div className={`${style.container}`}>
      <div className={style.contentContainer}>
        <div className={style.content}>
          <StandardBlocksLayout blocks={blocks} blockStyles={`${blockStyles}`} />
        </div>
        {/* we can add children outside of the Blocks here */}
        <div className={style.customChildren}>{children}</div>
      </div>
      <div className={`${style.footer} js-global-footer`}>
        <MainFooter showMenu={false} showSocial={true} />
      </div>
    </div>
  );
};

export default GenericPageLayout;
